<template>
  <div
    class="flex flex--column flex__item bg-white py-small"
    :class="{
      'ml-tiny': marginLeft,
      'mr-tiny': marginRight,
      'o-pack__item--no-width': evenWidth,
    }"
  >
    <div class="flex flex--justify-center flex--center">
      <i class="fa fa-solid" :class="icon"></i>
      <h4 class="color-grey mb-none ml-tiny">{{ displayValue }}</h4>
    </div>
    <div class="flex flex--center flex--justify-center">
      <span class="text-center"> {{ text }} </span>
      <ak-tooltip theme="light" placement="bottom">
        <template #trigger>
          <i class="icon-information-circled color-grey-light ml-tiny"></i>
        </template>
        {{ popoverText }}
      </ak-tooltip>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
export default defineComponent({
  name: 'AkEmailStatsBox',
  components: {
    [Icon.name]: Icon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    popoverText: {
      type: String,
      required: true,
    },
    displayValue: {
      type: [String, Number],
      required: true,
    },
    icon: {
      type: String,
      default: 'mail-open',
    },
    marginLeft: {
      type: Boolean,
      default: true,
    },
    marginRight: {
      type: Boolean,
      default: true,
    },
    evenWidth: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {}
  },
})
</script>
